import React from 'react';

import ErrorHandlingProvider from '@swf/core/providers/ErrorHandlingProvider';

import WizardAdapter from './components/WizardAdapter/WizardAdapter';

const ErrorHandler: React.FC<React.PropsWithChildren> = ({ children }) => (
  <ErrorHandlingProvider>
    <WizardAdapter />
    {children}
  </ErrorHandlingProvider>
);

export default ErrorHandler;
